import React, {useEffect} from 'react';
import Common from "./common";
import store from "../../storeWire";
import {setData} from "../../store/slice/customerLedger";
import axios from "axios";
import Helper from "../../application/helper";
import {usePage} from "@inertiajs/inertia-react";

const Show = () => {
    const p = usePage();
    useEffect(() => {
        axios.get(Helper.route('customerledger.show', {
            customerledger: p.props.customer_ledger
        })).then((res) => {
            if (res.data.data.id !== undefined && res.data.data.id) {
                store.dispatch(setData(res.data.data));
            } else {
                window.location.href = Helper.route('customer-ledger.index');
            }
        }).catch(() => {
            window.location.href = Helper.route('customer-ledger.index');
        });
    }, []);
    return <><Common/></>;
}

export default Show;
